import React from "react";


const CollectibleIcon: React.FC<{ widthCss?: string, step?: string }> = ({widthCss = 'w-5', step = ''}) =>
  <div className={`${widthCss} inline-block relative`}>
    <img className={`object-cover`} src={`${process.env.REACT_APP_STATIC_ASSETS}/images/collectible-card.png`}/>
    { step &&
      <img className={`absolute -bottom-1 -right-1 w-3`} src={`${process.env.REACT_APP_STATIC_ASSETS}/images/${step}-step.png`}/>
    }
  </div>
;

export {CollectibleIcon};